<template>
  <div class="container my-4">
    <v-toolbar class="mb-3" :elevation="1">
      {{concept.title || 'Not found'}}
      <v-spacer></v-spacer>
      <a
              target="_blank" rel="noopener noreferrer"
              :href="concept.url || '#'"
      >
        <v-btn text>
          Edit on
          <v-icon right>mdi-github-face</v-icon>
        </v-btn>
      </a>
    </v-toolbar>
    <v-card :tile="true" :elevation="1" class="pa-7">
      <VueShowdown :markdown="concept.content || ''"></VueShowdown>
    </v-card>
  </div>
</template>

<script>
  import VueShowdown from 'vue-showdown';

  export default {
    name: "ConceptViewer",
    components: VueShowdown,
    computed: {
      concept() {
        return this.$store.getters.concept(this.$route.params.slug)
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 70%;
    margin: auto;
  }

  a {
    text-decoration: none !important;
  }
</style>
